import styled from 'styled-components';

export const DivMain = styled.div`
    transition: .1s;
    :active{
        transform:translateY(10px);

    }
`
export const DivMainPopupVerifyEmail = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    border: 1px solid #00B9BB;
    padding: 20px;
    border-radius: 9px;
    background: #0594a5;
    >div{
        display:inherit;
        flex-direction:inherit;
        justify-content:inherit;
        align-items:inherit;
        >span{
            font-size:20px;
            margin:0 0 20px 0;
            display:none;
        }
        >input{
            margin:0 0 20px 0;
            border:0;
            border-bottom: 3px solid #51d6d8;
            border-radius:4px;
            height:40px;
            width:400px;
            padding: 0 0 0 10px;
            font-size:20px;
            background:#eaecec;
            color:#000;
            ::placeholder{
                color:gray;
                opacity:0.6;
            }
        }
    }
    >button{
            border:3px solid #00b9bb;
            border-radius: 5px;
            height: 45px;
            padding: 10px;
            font-size: 20px;
            color: #f6f6f6;
            background: #0594a5;
            cursor:pointer;
            transition:0.5s;
            :hover{
                transform:scale(1.05);
            }
            :active{
                transform: translateY( 5px);
            }
        }
        @media(max-width:790px){
        width:100%;
        >div{
            >input{
                width:100%;
            }
        }
    }
`;

export const P = styled.p`
    font-size:25px;
    margin:0 0 40px 0;
    color: #f6f6f6;
    line-height: 40px;
    text-align:center;
`
